<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <div
        v-if="mensagem !== ''"
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <Dialog
        :id="'dialogEditPlano'"
        titulo="Plano"
        ref="dialog"
        :modal="propView == 'modal'"
      >
        <div class="text-left">
          <div class="row">
            <div
              class="col-sm-12"
              v-if="retornaSite() !== 'Stream1x2' && retornaSite() !== '7live'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Site</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="sites"
                    v-model="item.site"
                    :erro="itemErros.site.status"
                  />
                  <div v-if="itemErros.site.status" class="invalid-feedback">
                    {{ itemErros.site.mensagem }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              class="col-sm-12"
              v-if="retornaSite() !== 'Stream1x2' && retornaSite() !== '7live'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Tipo</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="[
                      { id: '', nome: 'Escolha um item' },
                      { id: 'assinante', nome: 'Assinante' },
                      { id: 'teste', nome: 'Teste' },
                      { id: 'ajuste', nome: 'Ajuste' },
                    ]"
                    v-model="item.tipo"
                    :erro="itemErros.tipo.status"
                  />
                  <div v-if="itemErros.tipo.status" class="invalid-feedback">
                    {{ itemErros.tipo.mensagem }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-12 col-form-label">Nome</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                v-bind:class="{ 'is-invalid': itemErros.nome.status }"
                type="text"
                v-model="item.nome"
                @keyup="enterSalvar"
              />
              <div v-if="itemErros.nome.status" class="invalid-feedback">
                {{ itemErros.nome.mensagem }}
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-12 col-form-label">Duração (dias)</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                v-bind:class="{ 'is-invalid': itemErros.duracao.status }"
                type="text"
                v-model="item.duracao"
                :disabled="this.item._id !== ''"
                @keyup="enterSalvar"
              />
              <div v-if="itemErros.duracao.status" class="invalid-feedback">
                {{ itemErros.duracao.mensagem }}
              </div>
            </div>
          </div>

          <div class="form-group row" v-if="retornaSite() == '7live'">
            <label class="col-sm-12 col-form-label">Valor</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                v-bind:class="{ 'is-invalid': itemErros.valor.status }"
                type="text"
                v-model="item.valor"
                :disabled="this.item._id !== ''"
                @keyup="enterSalvar"
              />
              <div v-if="itemErros.valor.status" class="invalid-feedback">
                {{ itemErros.valor.mensagem }}
              </div>
            </div>
          </div>
        </div>

        <template v-slot:rodape>
          <button
            type="button"
            class="btn btn-secondary"
            v-if="view == 'modal'"
            data-dismiss="modal"
          >
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" @click="salvarItem()">
            Salvar
          </button>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";
import Combo from "../components/Combo.vue";

export default {
  name: "EditPlano",
  components: { Dialog, Combo },
  props: {
    propView: { type: String, default: "modal" },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    async carregarItem(id) {
      //* Limpa os campos
      this.novo();

      //* Carrega os dados
      var itemEdit = {};

      const response = await api.get("/plano/" + id);
      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        itemEdit = response.data.itens[0];
        this.item._id = itemEdit._id;
        this.item.site = itemEdit.site;
        this.item.nome = itemEdit.nome;
        this.item.duracao = itemEdit.duracao;
        this.item.valor = itemEdit.valor;
        this.item.tipo = itemEdit.tipo ? itemEdit.tipo : "";
      }
    },
    async salvarItem() {
      this.mensagem = "";
      this.itemErros = util.errosLimpar(this.itemErros);

      var apiRequest;

      var body = this.item;

      if (this.item._id == "") {
        apiRequest = await api.post("/plano", body);
      } else {
        apiRequest = await api.put("/plano/" + this.item._id, body);
      }

      if (apiRequest.data.erro) {
        util.errosProcessar(this.itemErros, apiRequest.data.erros);
        console.log(this.itemErros);
      } else {
        if (this.propView !== "modal") {
          this.mensagem = "Plano alterado com sucesso!";
        } else {
          this.$refs.dialog.fechar();
        }

        this.$emit("save-item");
      }
    },
    async novo() {
      this.$set(this.item, "_id", "");
      this.$set(this.item, "site", this.retornaSite());
      this.$set(this.item, "nome", "");
      this.$set(this.item, "duracao", "");
      this.$set(this.item, "valor", "");
      this.$set(this.item, "tipo", "");

      this.$set(this.item, "senha", "");
      this.itemErros = util.errosLimpar(this.itemErros);
    },
    async enterSalvar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.salvarItem();
      }
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
  },
  async mounted() {
    this.sites.push({
      id: this.retornaSite(),
      nome:
        this.retornaSite() == "Stream1x2" ? "Stream 1x2" : this.retornaSite(),
    });

    if (this.retornaSite() == "Weddbets") {
      this.sites.push({ id: "Bll", nome: "Bll" });
    }

    await this.novo();

    this.view = this.propView;
  },
  data: function () {
    return {
      item: {
        _id: "",
        site: "",
        nome: "",
        duracao: "",
        valor: "",
        tipo: "",
      },
      itemErros: {
        site: { status: false, mensagem: "" },
        nome: { status: false, mensagem: "" },
        duracao: { status: false, mensagem: "" },
        valor: { status: false, mensagem: "" },
        tipo: { status: false, mensagem: "" },
      },
      sites: [],
      view: "",
      mensagem: "",
    };
  },
};
</script>

<style></style>
